/* eslint-disable */
// 向本地存储里放数据
export function setStorage(name, data) {
  // array / json
  if (typeof data === 'object') {
    const jsonString = JSON.stringify(data)
    window.localStorage.setItem(name, jsonString)
  }
  // number / string / boolean
  else if (typeof data === 'number' || typeof data === 'string' || typeof data === 'boolean') {
    const jsonString = JSON.stringify(data)
    window.localStorage.setItem(name, jsonString)
  }
  // undefined / function
  else {
    alert('该数据类型不能用于本地存储')
  }
}

// 从本地存储获取数据
export function getStorage(name) {
  const data = window.localStorage.getItem(name)
  if (data) {
    // JSON.parse
    return JSON.parse(data)
  } else {
    return ''
  }
}

// 删除本地存储
export function removeStorage(name) {
  window.localStorage.removeItem(name)
}



// WEBPACK FOOTER //
// ./src/utils/localStorage.js